import { render, staticRenderFns } from "./overdue-bill.vue?vue&type=template&id=fb94e4a0&scoped=true&"
import script from "./overdue-bill.vue?vue&type=script&lang=js&"
export * from "./overdue-bill.vue?vue&type=script&lang=js&"
import style0 from "./overdue-bill.vue?vue&type=style&index=0&id=fb94e4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb94e4a0",
  null
  
)

export default component.exports